function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M500,0h0C302.59.18,141.86,160.92,141.68,358.33c0,184.43,298.05,583.68,332,628.57a32.56,32.56,0,0,0,21.72,12.8,39.58,39.58,0,0,0,4.59.3,33,33,0,0,0,20-6.76,32.18,32.18,0,0,0,6.23-6.34c34-44.89,332.1-444.32,332.1-628.57C858.14,160.92,697.41.18,500,0ZM296.14,153A290.31,290.31,0,0,1,499.83,70.23c1.43,0,2.87.06,4.3.06,159.38,2.25,286,128.88,288.26,288,0,137.77-221.68,455.35-292.39,553.11C429.27,813.68,207.54,496,207.54,358.57A290.52,290.52,0,0,1,296.14,153Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M500,560.48c111.46,0,202.14-90.69,202.14-202.15S611.36,156.29,500,156.17h0c-111.46,0-202.14,90.69-202.14,202.16S388.54,560.48,500,560.48ZM363.78,358.33c0-75.1,61.11-136.2,136.22-136.2s136.22,61.1,136.22,136.2S575,494.46,500,494.52,363.78,433.43,363.78,358.33Z"
});

function SvgPlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlot);
export default __webpack_public_path__ + "static/media/plot.1f36d9ab.svg";
export { ForwardRef as ReactComponent };